<template>
  <div class="container">
    <div class="row text-center mt-5">
        <div class="col-md-12">
            <img src="@/assets/order.svg" class="img-fluid" alt="">
        </div>
        <div class="mt-5">
            <h1 class="display-5">Order Confirm, We Will Delivery You Soon!</h1>
        </div>
        <div class="mt-5 animate__animated animate__backInLeft">
            <router-link to="/product" class="btn btn-primary">Go Back To Products</router-link>
         </div>
    </div>

  </div>
</template>

<script>
export default {
    name: "OrderBill",
}
</script>

<style>

</style>